/**
 * CRO Location Index
 *
 * Originally generated from product export CSV via:
 *   python3 scripts/generate_location_index.py docs/products_export_1.csv
 *
 * When adding a new location/college in Shopify:
 *   1. Tag the products with structured tags (loc-name:, loc-type:, category:, parent-state:)
 *   2. Add the location entry to this file manually (slug must match the product tag exactly)
 *   3. Or re-export CSV and re-run the generator script
 *
 * Contains 320 locations + 5 military branches and 16 product types.
 */
window.CRO = window.CRO || {};

window.CRO.locationIndex = [
  {
    "name": "Acadia",
    "slug": "acadia",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "maine"
    ]
  },
  {
    "name": "Adirondacks",
    "slug": "adirondacks",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Alabama",
    "slug": "alabama",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Alaska",
    "slug": "alaska",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Alexandria",
    "slug": "alexandria",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "virginia"
    ]
  },
  {
    "name": "America",
    "slug": "america",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Appalachian State University",
    "slug": "appalachian-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "Arizona",
    "slug": "arizona",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Arizona State University",
    "slug": "arizona-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "arizona"
    ]
  },
  {
    "name": "Arkansas",
    "slug": "arkansas",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Atlanta",
    "slug": "atlanta",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "georgia"
    ]
  },
  {
    "name": "Auburn University",
    "slug": "auburn-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "alabama"
    ]
  },
  {
    "name": "Austin",
    "slug": "austin",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Australia",
    "slug": "australia",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Bangkok",
    "slug": "bangkok",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Baylor University",
    "slug": "baylor-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Berkeley",
    "slug": "berkeley",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Berkshires",
    "slug": "berkshires",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Bermuda",
    "slug": "bermuda",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Big Bend",
    "slug": "big-bend",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Big Sur",
    "slug": "big-sur",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Birmingham",
    "slug": "birmingham",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "alabama"
    ]
  },
  {
    "name": "Block Island",
    "slug": "block-island",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "rhode-island"
    ]
  },
  {
    "name": "Boise State University",
    "slug": "boise-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "idaho"
    ]
  },
  {
    "name": "Boston",
    "slug": "boston",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Boston Classic",
    "slug": "boston-classic",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Boston College",
    "slug": "boston-college",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Boston University",
    "slug": "boston-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Brigham Young University (BYU)",
    "slug": "brigham-young-university-byu",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "utah"
    ]
  },
  {
    "name": "Brooklyn",
    "slug": "brooklyn",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Brown University",
    "slug": "brown-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "rhode-island"
    ]
  },
  {
    "name": "Buffalo",
    "slug": "buffalo",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "California",
    "slug": "california",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "California Surf",
    "slug": "california-surf",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Canada",
    "slug": "canada",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Cape Cod",
    "slug": "cape-cod",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Carmel",
    "slug": "carmel",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Catalina",
    "slug": "catalina",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Central Park",
    "slug": "central-park",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Charleston",
    "slug": "charleston",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "south-carolina"
    ]
  },
  {
    "name": "Charlotte",
    "slug": "charlotte",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "Chattanooga",
    "slug": "chattanooga",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "tennessee"
    ]
  },
  {
    "name": "Chesapeake Bay",
    "slug": "chesapeake-bay",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "maryland",
      "virginia"
    ]
  },
  {
    "name": "Chicago",
    "slug": "chicago",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "illinois"
    ]
  },
  {
    "name": "Cincinnati",
    "slug": "cincinnati",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "ohio"
    ]
  },
  {
    "name": "Clemson University",
    "slug": "clemson-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "south-carolina"
    ]
  },
  {
    "name": "Cleveland",
    "slug": "cleveland",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "ohio"
    ]
  },
  {
    "name": "Colorado",
    "slug": "colorado",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Colorado State University",
    "slug": "colorado-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Columbia University",
    "slug": "columbia-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Columbus",
    "slug": "columbus",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "ohio"
    ]
  },
  {
    "name": "Connecticut",
    "slug": "connecticut",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Cornell University",
    "slug": "cornell-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Coronado",
    "slug": "coronado",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Dallas",
    "slug": "dallas",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Dartmouth College",
    "slug": "dartmouth-college",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "new-hampshire"
    ]
  },
  {
    "name": "Daytona Beach",
    "slug": "daytona-beach",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Delaware",
    "slug": "delaware",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Denver",
    "slug": "denver",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Detroit",
    "slug": "detroit",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "michigan"
    ]
  },
  {
    "name": "Door County",
    "slug": "door-county",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "wisconsin"
    ]
  },
  {
    "name": "Duke University",
    "slug": "duke-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "East Carolina University",
    "slug": "east-carolina-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "Eiffel Tower",
    "slug": "eiffel-tower",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Emerald Coast",
    "slug": "emerald-coast",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Empire State",
    "slug": "empire-state",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "England",
    "slug": "england",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Europe",
    "slug": "europe",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Finger Lakes",
    "slug": "finger-lakes",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Fire Island",
    "slug": "fire-island",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Florida",
    "slug": "florida",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Florida Keys",
    "slug": "florida-keys",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Florida State University",
    "slug": "florida-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Fort Worth",
    "slug": "fort-worth",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "France",
    "slug": "france",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Franklin",
    "slug": "franklin",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "tennessee"
    ]
  },
  {
    "name": "Georgia",
    "slug": "georgia",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Georgia Tech",
    "slug": "georgia-tech",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "georgia"
    ]
  },
  {
    "name": "Germany",
    "slug": "germany",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Glacier",
    "slug": "glacier",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "montana"
    ]
  },
  {
    "name": "Glacier Park",
    "slug": "glacier-park",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "montana"
    ]
  },
  {
    "name": "Golden Gate Park",
    "slug": "golden-gate-park",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Golden Isles",
    "slug": "golden-isles",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "georgia"
    ]
  },
  {
    "name": "Gonzaa University",
    "slug": "gonzaa-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "washington"
    ]
  },
  {
    "name": "Gonzaga University",
    "slug": "gonzaga-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "washington"
    ]
  },
  {
    "name": "Grand Canyon",
    "slug": "grand-canyon",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "arizona"
    ]
  },
  {
    "name": "Grand Teton",
    "slug": "grand-teton",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "wyoming"
    ]
  },
  {
    "name": "Great Lakes",
    "slug": "great-lakes",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "illinois",
      "indiana",
      "michigan",
      "minnesota",
      "new-york-state",
      "ohio",
      "pennsylvania",
      "wisconsin"
    ]
  },
  {
    "name": "Great Smoky Mountains",
    "slug": "great-smoky-mountains",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "tennessee"
    ]
  },
  {
    "name": "Greece",
    "slug": "greece",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Hamptons",
    "slug": "hamptons",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Harvard University",
    "slug": "harvard-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Hawaii",
    "slug": "hawaii",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Hawaii Journal",
    "slug": "hawaii-journal",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Hawaiian Isles",
    "slug": "hawaiian-isles",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "hawaii"
    ]
  },
  {
    "name": "High Line New York",
    "slug": "high-line-new-york",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Hill Country",
    "slug": "hill-country",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Hilton Head",
    "slug": "hilton-head",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "south-carolina"
    ]
  },
  {
    "name": "Hollywood",
    "slug": "hollywood",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Houston",
    "slug": "houston",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Howard University",
    "slug": "howard-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "washington-dc"
    ]
  },
  {
    "name": "Hudson Valley",
    "slug": "hudson-valley",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Idaho",
    "slug": "idaho",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Illinois",
    "slug": "illinois",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Indiana",
    "slug": "indiana",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Indiana University",
    "slug": "indiana-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "indiana"
    ]
  },
  {
    "name": "Indianapolis",
    "slug": "indianapolis",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "indiana"
    ]
  },
  {
    "name": "Iowa",
    "slug": "iowa",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Iowa State University",
    "slug": "iowa-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "iowa"
    ]
  },
  {
    "name": "Ireland",
    "slug": "ireland",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Israel",
    "slug": "israel",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Italy",
    "slug": "italy",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Jackson Hole",
    "slug": "jackson-hole",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "wyoming"
    ]
  },
  {
    "name": "Jacksonville",
    "slug": "jacksonville",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "James Madison University",
    "slug": "james-madison-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "virginia"
    ]
  },
  {
    "name": "Jersey Shore",
    "slug": "jersey-shore",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-jersey"
    ]
  },
  {
    "name": "Johns Hopkins",
    "slug": "johns-hopkins",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "maryland"
    ]
  },
  {
    "name": "Johns Hopkins University",
    "slug": "johns-hopkins-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "maryland"
    ]
  },
  {
    "name": "Kansas",
    "slug": "kansas",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Kansas City",
    "slug": "kansas-city",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "missouri"
    ]
  },
  {
    "name": "Kansas State University",
    "slug": "kansas-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "kansas"
    ]
  },
  {
    "name": "Kauai",
    "slug": "kauai",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "hawaii"
    ]
  },
  {
    "name": "Kentucky",
    "slug": "kentucky",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Kentucky Derby",
    "slug": "kentucky-derby",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Lady Liberty",
    "slug": "lady-liberty",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Lake Michigan",
    "slug": "lake-michigan",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "illinois",
      "indiana",
      "michigan",
      "wisconsin"
    ]
  },
  {
    "name": "Lake Tahoe",
    "slug": "lake-tahoe",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Las Vegas",
    "slug": "las-vegas",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "nevada"
    ]
  },
  {
    "name": "Little Rock",
    "slug": "little-rock",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "arkansas"
    ]
  },
  {
    "name": "London",
    "slug": "london",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Long Island",
    "slug": "long-island",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Los Angeles",
    "slug": "los-angeles",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Louisiana",
    "slug": "louisiana",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Louisiana State University (LSU)",
    "slug": "louisiana-state-university-lsu",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "louisiana"
    ]
  },
  {
    "name": "Mackinac Island",
    "slug": "mackinac-island",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "michigan"
    ]
  },
  {
    "name": "Maine",
    "slug": "maine",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Malibu",
    "slug": "malibu",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Marin",
    "slug": "marin",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Marin County",
    "slug": "marin-county",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Marthas Vineyard",
    "slug": "marthas-vineyard",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Maryland",
    "slug": "maryland",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Massachusetts",
    "slug": "massachusetts",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Massachusetts Institute of Technology (MIT)",
    "slug": "massachusetts-institute-of-technology-mit",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Maui",
    "slug": "maui",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "hawaii"
    ]
  },
  {
    "name": "Memphis",
    "slug": "memphis",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "tennessee"
    ]
  },
  {
    "name": "Mexico",
    "slug": "mexico",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Miami",
    "slug": "miami",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Michigan",
    "slug": "michigan",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Michigan State University",
    "slug": "michigan-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "michigan"
    ]
  },
  {
    "name": "Milwaukee",
    "slug": "milwaukee",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "wisconsin"
    ]
  },
  {
    "name": "Minneapolis St Paul",
    "slug": "minneapolis-st-paul",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "minnesota"
    ]
  },
  {
    "name": "Minnesota",
    "slug": "minnesota",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Mississippi",
    "slug": "mississippi",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Mississippi Coast",
    "slug": "mississippi-coast",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "mississippi"
    ]
  },
  {
    "name": "Mississippi State University",
    "slug": "mississippi-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "mississippi"
    ]
  },
  {
    "name": "Missouri",
    "slug": "missouri",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "University of Missouri (Mizzou)",
    "slug": "missouri-university-of-mizzou",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "missouri"
    ]
  },
  {
    "name": "Montana",
    "slug": "montana",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Montana State University",
    "slug": "montana-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "montana"
    ]
  },
  {
    "name": "Nantucket",
    "slug": "nantucket",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Napa Valley",
    "slug": "napa-valley",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Nashville",
    "slug": "nashville",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "tennessee"
    ]
  },
  {
    "name": "Nebraska",
    "slug": "nebraska",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Nevada",
    "slug": "nevada",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "New England",
    "slug": "new-england",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "connecticut",
      "maine",
      "massachusetts",
      "new-hampshire",
      "rhode-island",
      "vermont"
    ]
  },
  {
    "name": "New Hampshire",
    "slug": "new-hampshire",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "New Jersey",
    "slug": "new-jersey",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "New Mexico",
    "slug": "new-mexico",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "New Orleans",
    "slug": "new-orleans",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "louisiana"
    ]
  },
  {
    "name": "New York City",
    "slug": "new-york-city",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "New York City Color",
    "slug": "new-york-city-color",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "New York State",
    "slug": "new-york-state",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "New York University",
    "slug": "new-york-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Newport",
    "slug": "newport",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "rhode-island"
    ]
  },
  {
    "name": "North Carolina",
    "slug": "north-carolina",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "North Carolina State University",
    "slug": "north-carolina-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "North Coast",
    "slug": "north-coast",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "North Dakota",
    "slug": "north-dakota",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Oahu",
    "slug": "oahu",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "hawaii"
    ]
  },
  {
    "name": "Oakland",
    "slug": "oakland",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Ohio",
    "slug": "ohio",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Ohio State University",
    "slug": "ohio-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "ohio"
    ]
  },
  {
    "name": "Oklahoma",
    "slug": "oklahoma",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Oklahoma City",
    "slug": "oklahoma-city",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "oklahoma"
    ]
  },
  {
    "name": "Oklahoma State University",
    "slug": "oklahoma-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "oklahoma"
    ]
  },
  {
    "name": "Omaha",
    "slug": "omaha",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "nebraska"
    ]
  },
  {
    "name": "Orange County",
    "slug": "orange-county",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Oregon",
    "slug": "oregon",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Oregon State University",
    "slug": "oregon-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "oregon"
    ]
  },
  {
    "name": "Orlando",
    "slug": "orlando",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Ottawa",
    "slug": "ottawa",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Outer Banks",
    "slug": "outer-banks",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "Palm Beach",
    "slug": "palm-beach",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Palm Springs",
    "slug": "palm-springs",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Paris",
    "slug": "paris",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Penn State University",
    "slug": "penn-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "pennsylvania"
    ]
  },
  {
    "name": "Pennsylvania",
    "slug": "pennsylvania",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Pepperdine University",
    "slug": "pepperdine-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Petaluma",
    "slug": "petaluma",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Philadelphia",
    "slug": "philadelphia",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "pennsylvania"
    ]
  },
  {
    "name": "Phoenix",
    "slug": "phoenix",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "arizona"
    ]
  },
  {
    "name": "Pittsburgh",
    "slug": "pittsburgh",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "pennsylvania"
    ]
  },
  {
    "name": "Portland Me",
    "slug": "portland-me",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "maine"
    ]
  },
  {
    "name": "Portland Or",
    "slug": "portland-or",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "oregon"
    ]
  },
  {
    "name": "Princeton University",
    "slug": "princeton-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "new-jersey"
    ]
  },
  {
    "name": "Provincetown",
    "slug": "provincetown",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "massachusetts"
    ]
  },
  {
    "name": "Purdue University",
    "slug": "purdue-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "indiana"
    ]
  },
  {
    "name": "Quebec",
    "slug": "quebec",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Queens",
    "slug": "queens",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Raleigh",
    "slug": "raleigh",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "Rhode Island",
    "slug": "rhode-island",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Richmond",
    "slug": "richmond",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "virginia"
    ]
  },
  {
    "name": "Rio De Janeiro",
    "slug": "rio-de-janeiro",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Rocky Mountain National Park",
    "slug": "rocky-mountain-national-park",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Roma",
    "slug": "roma",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Route 66",
    "slug": "route-66",
    "type": "region",
    "category": "geography"
  },
  {
    "name": "Rutgers University",
    "slug": "rutgers-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "new-jersey"
    ]
  },
  {
    "name": "Sacramento",
    "slug": "sacramento",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "San Antonio",
    "slug": "san-antonio",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "San Diego",
    "slug": "san-diego",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "San Francisco",
    "slug": "san-francisco",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "San Francisco City",
    "slug": "san-francisco-city",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "San Francisco Classic",
    "slug": "san-francisco-classic",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Santa Barbara",
    "slug": "santa-barbara",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Santa Cruz",
    "slug": "santa-cruz",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Santa Fe",
    "slug": "santa-fe",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "new-mexico"
    ]
  },
  {
    "name": "Santa Monica",
    "slug": "santa-monica",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Savannah",
    "slug": "savannah",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "georgia"
    ]
  },
  {
    "name": "Scotland",
    "slug": "scotland",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Seattle",
    "slug": "seattle",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "washington"
    ]
  },
  {
    "name": "Ski Aspen",
    "slug": "ski-aspen",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Ski Colorado",
    "slug": "ski-colorado",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Ski Montana",
    "slug": "ski-montana",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "montana"
    ]
  },
  {
    "name": "Ski Sun Valley",
    "slug": "ski-sun-valley",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "idaho"
    ]
  },
  {
    "name": "Ski Tahoe",
    "slug": "ski-tahoe",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Ski Telluride",
    "slug": "ski-telluride",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Ski Utah",
    "slug": "ski-utah",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "utah"
    ]
  },
  {
    "name": "Ski Vail",
    "slug": "ski-vail",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Ski Vermont",
    "slug": "ski-vermont",
    "type": "ski-resort",
    "category": "geography",
    "parentStates": [
      "vermont"
    ]
  },
  {
    "name": "Sonoma",
    "slug": "sonoma",
    "type": "region",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Sonoma County",
    "slug": "sonoma-county",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "South Carolina",
    "slug": "south-carolina",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "South Dakota",
    "slug": "south-dakota",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "St Augustine",
    "slug": "st-augustine",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "St Louis",
    "slug": "st-louis",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "missouri"
    ]
  },
  {
    "name": "Stanford University",
    "slug": "stanford-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Summer Colorado",
    "slug": "summer-colorado",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "Sweden",
    "slug": "sweden",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Switzerland",
    "slug": "switzerland",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Syracuse University",
    "slug": "syracuse-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "new-york-state"
    ]
  },
  {
    "name": "Tampa St Pete",
    "slug": "tampa-st-pete",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Tennessee",
    "slug": "tennessee",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Texas",
    "slug": "texas",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Texas a M University",
    "slug": "texas-a-m-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Texas Christian University (TCU)",
    "slug": "texas-christian-university-tcu",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "Texas Tech University",
    "slug": "texas-tech-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "The Keys",
    "slug": "the-keys",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "Transylvania",
    "slug": "transylvania",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Tulsa",
    "slug": "tulsa",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "oklahoma"
    ]
  },
  {
    "name": "University of Alabama",
    "slug": "university-of-alabama",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "alabama"
    ]
  },
  {
    "name": "University of Arizona",
    "slug": "university-of-arizona",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "arizona"
    ]
  },
  {
    "name": "University of Arkansas",
    "slug": "university-of-arkansas",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "arkansas"
    ]
  },
  {
    "name": "University of California Berkeley",
    "slug": "university-of-california-berkeley",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "University of Central Florida",
    "slug": "university-of-central-florida",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "University of Colorado Boulder",
    "slug": "university-of-colorado-boulder",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "colorado"
    ]
  },
  {
    "name": "University of Connecticut",
    "slug": "university-of-connecticut",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "connecticut"
    ]
  },
  {
    "name": "University of Florida",
    "slug": "university-of-florida",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "florida"
    ]
  },
  {
    "name": "University of Georgia",
    "slug": "university-of-georgia",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "georgia"
    ]
  },
  {
    "name": "University of Illinois",
    "slug": "university-of-illinois",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "illinois"
    ]
  },
  {
    "name": "University of Iowa",
    "slug": "university-of-iowa",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "iowa"
    ]
  },
  {
    "name": "University of Kansas",
    "slug": "university-of-kansas",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "kansas"
    ]
  },
  {
    "name": "University of Kentucky",
    "slug": "university-of-kentucky",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "kentucky"
    ]
  },
  {
    "name": "University of Louisville",
    "slug": "university-of-louisville",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "kentucky"
    ]
  },
  {
    "name": "University of Maryland",
    "slug": "university-of-maryland",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "maryland"
    ]
  },
  {
    "name": "University of Michigan",
    "slug": "university-of-michigan",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "michigan"
    ]
  },
  {
    "name": "University of Minnesota",
    "slug": "university-of-minnesota",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "minnesota"
    ]
  },
  {
    "name": "University of Mississippi (Ole Miss)",
    "slug": "university-of-mississippi-ole-miss",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "mississippi"
    ]
  },
  {
    "name": "University of Montana",
    "slug": "university-of-montana",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "montana"
    ]
  },
  {
    "name": "University of Nebraska",
    "slug": "university-of-nebraska",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "nebraska"
    ]
  },
  {
    "name": "University of North Carolina",
    "slug": "university-of-north-carolina",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "University of Notre Dame",
    "slug": "university-of-notre-dame",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "indiana"
    ]
  },
  {
    "name": "University of Oklahoma",
    "slug": "university-of-oklahoma",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "oklahoma"
    ]
  },
  {
    "name": "University of Oregon",
    "slug": "university-of-oregon",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "oregon"
    ]
  },
  {
    "name": "University of Pennsylvania",
    "slug": "university-of-pennsylvania",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "pennsylvania"
    ]
  },
  {
    "name": "University of Pittsburgh",
    "slug": "university-of-pittsburgh",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "pennsylvania"
    ]
  },
  {
    "name": "University of South Carolina",
    "slug": "university-of-south-carolina",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "south-carolina"
    ]
  },
  {
    "name": "University of Southern California (USC)",
    "slug": "university-of-southern-california-usc",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "University of Tennessee",
    "slug": "university-of-tennessee",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "tennessee"
    ]
  },
  {
    "name": "University of Texas",
    "slug": "university-of-texas",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "texas"
    ]
  },
  {
    "name": "University of Utah",
    "slug": "university-of-utah",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "utah"
    ]
  },
  {
    "name": "University of Virginia",
    "slug": "university-of-virginia",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "virginia"
    ]
  },
  {
    "name": "University of Washington",
    "slug": "university-of-washington",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "washington"
    ]
  },
  {
    "name": "University of Wisconsin",
    "slug": "university-of-wisconsin",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "wisconsin"
    ]
  },
  {
    "name": "Utah",
    "slug": "utah",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Vancouver",
    "slug": "vancouver",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Vanderbilt University",
    "slug": "vanderbilt-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "tennessee"
    ]
  },
  {
    "name": "Vermont",
    "slug": "vermont",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Villanova University",
    "slug": "villanova-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "pennsylvania"
    ]
  },
  {
    "name": "Virgin Islands",
    "slug": "virgin-islands",
    "type": "country",
    "category": "geography"
  },
  {
    "name": "Virginia",
    "slug": "virginia",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Virginia Beach",
    "slug": "virginia-beach",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "virginia"
    ]
  },
  {
    "name": "Virginia Commonwealth University (VCU)",
    "slug": "virginia-commonwealth-university-vcu",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "virginia"
    ]
  },
  {
    "name": "Virginia Tech",
    "slug": "virginia-tech",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "virginia"
    ]
  },
  {
    "name": "Wake Forest",
    "slug": "wake-forest",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "Wake Forest University",
    "slug": "wake-forest-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "north-carolina"
    ]
  },
  {
    "name": "Washington",
    "slug": "washington",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Washington Dc",
    "slug": "washington-dc",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "washington-dc"
    ]
  },
  {
    "name": "Washington St",
    "slug": "washington-st",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Washington State University",
    "slug": "washington-state-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "washington"
    ]
  },
  {
    "name": "West Virginia",
    "slug": "west-virginia",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "West Virginia University",
    "slug": "west-virginia-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "west-virginia"
    ]
  },
  {
    "name": "Wisconsin",
    "slug": "wisconsin",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Wyoming",
    "slug": "wyoming",
    "type": "state",
    "category": "geography"
  },
  {
    "name": "Yale University",
    "slug": "yale-university",
    "type": "college",
    "category": "collegiate",
    "parentStates": [
      "connecticut"
    ]
  },
  {
    "name": "Yellowstone",
    "slug": "yellowstone",
    "type": "city",
    "category": "geography",
    "parentStates": [
      "wyoming"
    ]
  },
  {
    "name": "Yosemite",
    "slug": "yosemite",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Yosemite National Park",
    "slug": "yosemite-national-park",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "california"
    ]
  },
  {
    "name": "Zion",
    "slug": "zion",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "utah"
    ]
  },
  {
    "name": "Zion National Park",
    "slug": "zion-national-park",
    "type": "national-park",
    "category": "geography",
    "parentStates": [
      "utah"
    ]
  },
  {
    "name": "Air Force",
    "slug": "air-force",
    "type": "military-branch",
    "category": "military",
    "customUrl": "/collections/all/category:military"
  },
  {
    "name": "Army",
    "slug": "army",
    "type": "military-branch",
    "category": "military",
    "customUrl": "/collections/all/category:military"
  },
  {
    "name": "Navy",
    "slug": "navy",
    "type": "military-branch",
    "category": "military",
    "customUrl": "/collections/all/category:military"
  },
  {
    "name": "Marines",
    "slug": "marines",
    "type": "military-branch",
    "category": "military",
    "customUrl": "/collections/all/category:military"
  },
  {
    "name": "Coast Guard",
    "slug": "coast-guard",
    "type": "military-branch",
    "category": "military",
    "customUrl": "/collections/all/category:military"
  }
];

window.CRO.productTypes = [
  {
    "name": "Apron",
    "slug": "apron"
  },
  {
    "name": "Art Print",
    "slug": "art-print"
  },
  {
    "name": "Bandana",
    "slug": "bandana"
  },
  {
    "name": "Beach Towel",
    "slug": "beach-towel"
  },
  {
    "name": "Dish Towel",
    "slug": "dish-towel"
  },
  {
    "name": "Glass",
    "slug": "glass"
  },
  {
    "name": "Journal",
    "slug": "journal"
  },
  {
    "name": "Mini Pillow Ornament",
    "slug": "mini-pillow-ornament"
  },
  {
    "name": "Mug",
    "slug": "mug"
  },
  {
    "name": "Pillow",
    "slug": "pillow"
  },
  {
    "name": "Pouch",
    "slug": "pouch"
  },
  {
    "name": "Thermal Bottle",
    "slug": "thermal-bottle"
  },
  {
    "name": "Thermal Tumbler",
    "slug": "thermal-tumbler"
  },
  {
    "name": "Tote Bag",
    "slug": "tote-bag"
  },
  {
    "name": "Tray",
    "slug": "tray"
  },
  {
    "name": "Xl Pillow",
    "slug": "xl-pillow"
  }
];

window.CRO.locationTypeLabels = {
  "state": "State",
  "city": "City",
  "college": "College",
  "national-park": "National Park",
  "region": "Region",
  "country": "Country",
  "ski-resort": "Ski Resort",
  "military-branch": "Military"
};

window.CRO.categoryLabels = {
  "geography": "Geography",
  "collegiate": "Collegiate",
  "holiday": "Holiday",
  "astrology": "Astrology",
  "military": "Military",
  "love-letters": "Love Letters",
  "mom-gift": "Mom Gift"
};
